<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'allocationManageIndex')">
            <!-- 调拨管理 -->
            <div slot="header">
                <a-form :form="filterForm1" layout="inline" class="store-one-form" v-show="dispatchType === 0">
                    <a-form-item label="出库仓库">
                        <a-select :options="warehouseOptions1" placeholder="请选择" v-decorator="['outWarehouseId']"></a-select>
                    </a-form-item>
                    <a-form-item label="入库仓库">
                        <a-select :options="warehouseOptions1" placeholder="请选择" v-decorator="['inWarehouseId']"></a-select>
                    </a-form-item>
                    <a-form-item label="审批状态">
                        <a-select placeholder="请选择" v-decorator="['approveState']">
                            <a-select-option value="0">待审核</a-select-option>
                            <a-select-option value="1">审核通过</a-select-option>
                            <a-select-option value="2">审核不通过</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="操作时间">
                        <a-range-picker style="width:100%;" v-decorator="['applyDate']" showTime></a-range-picker>
                    </a-form-item>
                    <a-form-item label="审核时间">
                        <a-range-picker style="width:100%;" v-decorator="['approvalDate']" showTime></a-range-picker>
                    </a-form-item>
                    <a-form-item label="操作人">
                        <a-input style="width:100%;" placeholder="请输入" v-decorator="['applyUserName']"></a-input>
                    </a-form-item>
                    <a-form-item label="审核人">
                        <a-input placeholder="请输入" v-decorator="['approvalUserName']"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" @click="search" :loading="searchLoading">筛选</a-button>
                        <a-button @click="handleReset()" :loading="searchLoading">重置</a-button>
                    </a-form-item>
                </a-form>
                <a-form :form="filterForm2" layout="inline" class="store-one-form" v-show="dispatchType === 1">
                    <a-form-item label="出库仓库">
                        <a-select :options="warehouseOptions1" placeholder="请选择" v-decorator="['outWarehouseId']"></a-select>
                    </a-form-item>
                    <a-form-item label="调拨门店" v-show="dispatchType === 1">
                        <a-select @change="shopChange" :options="shopOptions" placeholder="请选择" v-decorator="['dispatchShopId']"></a-select>
                    </a-form-item>
                    <a-form-item label="入库仓库">
                        <a-select :options="warehouseOptions2" placeholder="请选择" v-decorator="['inWarehouseId']"></a-select>
                    </a-form-item>
                    <a-form-item label="审批状态">
                        <a-select placeholder="请选择" v-decorator="['approveState']">
                            <a-select-option value="0">待审核</a-select-option>
                            <a-select-option value="1">审核通过</a-select-option>
                            <a-select-option value="2">审核不通过</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="操作时间">
                        <a-range-picker style="width:100%;" v-decorator="['applyDate']" showTime></a-range-picker>
                    </a-form-item>
                    <a-form-item label="审核时间">
                        <a-range-picker style="width:100%;" v-decorator="['approvalDate']" showTime></a-range-picker>
                    </a-form-item>
                    <a-form-item label="操作人">
                        <a-input style="width:100%;" placeholder="请输入" v-decorator="['applyUserName']"></a-input>
                    </a-form-item>
                    <a-form-item label="审核人">
                        <a-input placeholder="请输入" v-decorator="['approvalUserName']"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" @click="search" :loading="searchLoading">筛选</a-button>
                        <a-button @click="handleReset()" :loading="searchLoading">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-tabs type="card" class="tabs-bar-no-margin" v-model="dispatchType" @change="tabsChange">
                <template slot="tabBarExtraContent">
                    <template v-if="getBtnByAuth('newStorageGoodsAllocationButton')">
                        <a-button v-if="Number(shopId) === -1" class="mb16" type="primary" @click="visibleAllocationModelSelect = true">商品调拨</a-button>
                        <a-button v-else type="primary" @click="goMaterielAllocationApply(0)">商品调拨</a-button>
                    </template>
                    <a-button v-else :disabled="true">商品调拨</a-button>
                </template>
                <a-tab-pane :key="0">
                    <template slot="tab">
                        <template v-if="Number(shopId) === -1">
                            系统自有-总平台仓库调拨记录
                        </template>
                        <template v-else>
                            系统自有-调拨记录
                        </template>
                    </template>
                    <div class="wrap-container-in">
                        <a-table
                        bordered
                        :columns="columns1"
                        :dataSource="dataSource1"
                        :pagination="pagination1"
                        :rowKey="record => record.id"
                        :loading="searchLoading"
                        @change="changePage"
                        class="wrap-table"
                        >
                            <template slot="index" slot-scope="key, row, index">
                                {{index + 1}}
                            </template>
                            <template slot="isEmpty" slot-scope="key, row, index">
                                {{key || "-"}}
                            </template>
                            <template slot="outState" slot-scope="key, row, index">
                                {{['待出库', '出库成功', '出库失败'][key]}}
                            </template>
                            <template slot="approveState" slot-scope="key, row, index">
                                {{['待审核', '审核通过', '审核不通过'][key]}}
                            </template>
                            <template slot="actions" slot-scope="key, row">
                                <template v-if="getBtnByAuth('updateStorage')">
                                    <a v-if="true" class="text-primary" @click="selfGoodsDispatchInfo(row)">调拨审批单查看</a>
                                    <span v-else class="text-disabled">调拨审批单查看</span>
                                </template>
                            </template>
                        </a-table>
                    </div>
                </a-tab-pane>
                <a-tab-pane v-if="Number(shopId) === -1" :key="1" tab="门店调拨记录">
                    <div class="wrap-container-in">
                        <a-table
                        bordered
                        :dataSource="dataSource2"
                        :columns="columns2"
                        :pagination="pagination2"
                        :rowKey="record => record.id"
                        :loading="searchLoading"
                        @change="changePage"
                        class="wrap-table"
                        >
                            <template slot="index" slot-scope="key, row, index">
                                {{index + 1}}
                            </template>
                            <template slot="isEmpty" slot-scope="key, row, index">
                                {{key || "-"}}
                            </template>
                            <template slot="outState" slot-scope="key, row, index">
                                {{['待出库', '出库成功', '出库失败'][key]}}
                            </template>
                            <template slot="approveState" slot-scope="key, row, index">
                                {{['待审核', '审核通过', '审核不通过'][key]}}
                            </template>
                            <template slot="actions" slot-scope="key, row">
                                <template v-if="getBtnByAuth('updateStorage')">
                                    <a v-if="true" class="text-primary" @click="selfGoodsDispatchInfo(row)">调拨审批单查看</a>
                                    <span v-else class="text-disabled">调拨审批单查看</span>
                                </template>
                            </template>
                        </a-table>
                    </div>
                </a-tab-pane>
            </a-tabs>
            <a-modal
            title="商品调拨"
            centered
            :visible="visibleAllocationModelSelect"
            @cancel="visibleAllocationModelSelect = false"
            :width="400"
            >
                <a-row>
                    <a-col class="text-center" :span="12">
                        <a-button type="primary" @click="goMaterielAllocationApply(0)">平台仓库调拨</a-button>
                    </a-col>
                    <a-col class="text-center" :span="12">
                        <a-button type="primary" @click="goMaterielAllocationApply(1)">调拨至其它门店</a-button>
                    </a-col>
                </a-row>
                <template slot="footer">
                    <a-button @click="visibleAllocationModelSelect = false">取消</a-button>
                </template>
            </a-modal>
        </content-view>
        <goods-allocation-apply-detail-modal ref="goodsAllocationApplyDetailModal"></goods-allocation-apply-detail-modal>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import goodsAllocationApplyDetailModal from "@/components/modules/storage/goods-allocation-apply-detail-modal.component";
    const columns1 = [
        {
            title: '序号',
            scopedSlots: { customRender: 'index' }
        },
        {
            title: '出库仓库',
            dataIndex: 'outWarehouseName',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '入库仓库',
            dataIndex: 'inWarehouseName',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '操作人',
            dataIndex: 'applyUserName',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '操作时间',
            dataIndex: 'applyTime',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '操作原因',
            dataIndex: 'reason',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '出库状态',
            dataIndex: 'state',
            scopedSlots: {customRender: 'outState'}
        },
        {
            title: '审批状态',
            dataIndex: 'approveState',
            scopedSlots: { customRender: 'approveState' }
        },
        {
            title: '审核人',
            dataIndex: 'approvalUserName',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '审核时间',
            dataIndex: 'approvalTime',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'actions' }
        }
    ];
    const columns2 = [
        {
            title: '序号',
            scopedSlots: { customRender: 'index' }
        },
        {
            title: '出库仓库',
            dataIndex: 'outWarehouseName',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '调拨门店',
            dataIndex: 'dispatchShopName',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '入库仓库',
            dataIndex: 'inWarehouseName',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '操作人',
            dataIndex: 'applyUserName',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '操作时间',
            dataIndex: 'applyTime',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '操作原因',
            dataIndex: 'reason',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '出库状态',
            dataIndex: 'state',
            scopedSlots: {customRender: 'outState'}
        },
        {
            title: '审批状态',
            dataIndex: 'approveState',
            scopedSlots: { customRender: 'approveState' }
        },
        {
            title: '审核人',
            dataIndex: 'approvalUserName',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '审核时间',
            dataIndex: 'approvalTime',
            scopedSlots: { customRender: 'isEmpty' }
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'actions' }
        }
    ];
    export default {
        name: 'materielManage',
        components: {
            goodsAllocationApplyDetailModal
        },
        props: {},
        data() {
            return {
                dispatchType: 0,
                warehouseOptions1: [],
                warehouseOptions2: [],
                columns1,
                columns2,
                dataSource1: [],
                dataSource2: [],
                pagination1: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                pagination2: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                searchLoading: false,
                visibleAllocationModelSelect: false,
                shopOptions: []
            };
        },
        watch: {
            'shopId'(val, oval) {
                this.filterForm1.resetFields();
                this.filterForm2.resetFields();
                this.warehouseOptions1 = [];
                this.warehouseOptions2 = [];
                this.dispatchType = 0;
                this.pagination1.current = 1;
                this.pagination2.current = 1;
                this.getWarehouseList();
                this.getSelfGoodsDispatchPage();
            },
            $route(val, oval) {
                if (val.name === 'allocationManageIndex') {
                    setTimeout(() => {
                        this.getSelfGoodsDispatchPage();
                    }, 200);
                }
            }
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            /**
             * @shopChange 搜索门店变更回调
             */
            shopChange(val) {
                    this.filterForm2.resetFields('inWarehouseId');
                    this.warehouseOptions2 = [];
                    this.getWarehouseList(val);
            },
            changePage(page) {
                this[`pagination${this.dispatchType + 1}`].pageSize = page.pageSize;
                this[`pagination${this.dispatchType + 1}`].current = page.current;
                this.getSelfGoodsDispatchPage();
            },
            // 重置筛选
            handleReset() {
                this[`filterForm${this.dispatchType + 1}`].resetFields();
                this.search();
            },
            search() {
                this[`pagination${this.dispatchType + 1}`].current = 1;
                this.getSelfGoodsDispatchPage();
            },
            /**
             * @goMaterielAllocation 跳转商品调拨
             */
            goMaterielAllocationApply(dispatchType) {
                this.visibleAllocationModelSelect = false;
                setTimeout(() => {
                    this.$router.push({name: 'materielAllocationApply', params: {dispatchType}});
                }, 300);
            },
            /**
             * @getShopList 获取门店列表
             */
            getShopList() {
                this.$api.totalPlatform.selectList({}).then(res => {
                    res.forEach(item => {
                        item.value = item.id;
                        item.label = item.name;
                    });
                    this.shopOptions = res.filter(item => String(item.id) !== '-1');
                });
            },
            /**
             * @getWarehouseList 获取门店下仓库列表
             */
            getWarehouseList(dispatchShopId) {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.selfWarehousePage({
                    body: {
                        shopId: dispatchShopId || this.shopId,
                        pageNum: 1,
                        pageSize: 999999
                    }
                }).then(res => {
                    if (res && res.data) {
                        res.data.forEach(item => {
                            item.label = item.warehouseName;
                            item.value = item.id;
                        });
                        if (dispatchShopId) {
                            this.warehouseOptions2 = res.data;
                        } else {
                            this.warehouseOptions1 = res.data;
                            if (String(this.shopId) !== '-1') {
                                this.warehouseOptions2 = res.data;
                            }
                        }
                    }
                });
            },
            /**
             * @getSelfGoodsDispatchPage 获取商品审批记录
             */
            getSelfGoodsDispatchPage() {
                if (!this.shopId || this.searchLoading) {
                    return false;
                }
                this[`filterForm${this.dispatchType + 1}`].validateFields((errors, values) => {
                    if (errors) return;
                    if (Boolean(values.applyDate) && Boolean(values.applyDate.length)) {
                        values.applyTimeStart = values.applyDate[0].format('YYYY-MM-DD HH:mm:ss');
                        values.applyTimeEnd = values.applyDate[1].format('YYYY-MM-DD HH:mm:ss');
                    }
                    if (Boolean(values.approvalDate) && Boolean(values.approvalDate.length)) {
                        values.approvalTimeStart = values.approvalDate[0].format('YYYY-MM-DD HH:mm:ss');
                        values.approvalTimeEnd = values.approvalDate[1].format('YYYY-MM-DD HH:mm:ss');
                    }
                    if (this.dispatchType !== 1) {
                        delete values.dispatchShopId;
                    }
                    delete values.applyDate;
                    delete values.approvalDate;
                    this.searchLoading = true;
                    this.$api.newStorage.selfGoodsDispatchPage({
                        body: {
                            ...values,
                            dispatchType: this.dispatchType,
                            pageNum: this[`pagination${this.dispatchType + 1}`].current,
                            pageSize: this[`pagination${this.dispatchType + 1}`].pageSize,
                            shopId: this.shopId
                        }
                    }).then(res => {
                        res.data.forEach(item => {
                            item.businessId = item.id;
                        });
                        if (Boolean(res) && Boolean(res.data)) {
                            this[`dataSource${this.dispatchType + 1}`] = res.data;
                        }
                        this[`pagination${this.dispatchType + 1}`].total = res.total;
                        this.searchLoading = false;
                    }).catch(err => {
                        this.searchLoading = false;
                    });
                });
            },
            /**
             * @tabsChange 标签切换
             */
            tabsChange() {
                let length = this[`dataSource${this.dispatchType + 1}`].length;
                if (length) {
                    return false;
                }
                this.getSelfGoodsDispatchPage();
            },
            /**
             * @selfGoodsDispatchInfo 查看审批单
             */
            selfGoodsDispatchInfo(row) {
                this.$refs.goodsAllocationApplyDetailModal.selfGoodsDispatchInfo(row);
            }
        },
        beforeCreate() {
            this.filterForm1 = this.$form.createForm(this);
            this.filterForm2 = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getShopList();
            this.getWarehouseList();
            this.getSelfGoodsDispatchPage();
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.tabs-bar-no-margin {
    .ant-tabs-top-bar {
        margin: 0!important;
    }
}
</style>
